import { shouldIncludeDevelopmentAssertions } from "@app/environmentsBasic";
import { getWebpackFile } from "@app/utils/WebpackGetFIle";

export async function checkBasicEnviro() {
	// assert that unnecessary imports arent included in init.ts by accident
	if (shouldIncludeDevelopmentAssertions()) {
		if (getWebpackFile("pixi.js")) {
			throw new Error("PIXI.js should NOT be included in init.ts entry, check imports!");
		}
		if (getWebpackFile("robotlegs")) {
			throw new Error("Robotlegs should NOT be included in init.ts entry, check imports!");
		}
		if (getWebpackFile("bf-gameserver-client")) {
			throw new Error("bf-gameserver-client should NOT be included in init.ts entry, check imports!");
		}
	}
}